import { PeripheralProcessingState } from './interface';

export const initialState: PeripheralProcessingState = {
  list: { data: [], status: null },
  saveStatus: null,
};
